import type { RootState } from 'store'

export const getOffer = (state: RootState) => state?.offer?.data ?? {}

export const getCompanyType = (state: RootState) =>
  state?.offer?.companyType ?? null

export const getOfferType = (state: RootState) =>
  state?.offer?.data?.wineOfferType?.code ?? ''

export const getOfferStatus = (state: RootState) =>
  state?.offer?.data?.wineOfferStatus?.code ?? ''
